import { createStyles, makeStyles } from "@material-ui/core";
import * as React from "react";

import { RelodeTheme } from "../";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            // TODO: JLC need to see where this appears
            shadow: {
                boxShadow: "2px -8px 8px -8px rgba(0, 0, 0, 0.2)",
                padding: "20px",
            },
        }),
    { name: "MobilePageFooterActions" }
);

export interface MobilePageFooterActionsProps {
    children?: React.ReactNode;
}

export const MobilePageFooterActions = (
    props: MobilePageFooterActionsProps
) => {
    const classes = useStyles({});

    return <div className={classes.shadow}>{props.children}</div>;
};
